const Loader = ({ width = 60, height = 50 }) => (
    <svg
        style={{
            margin: 'auto',
            display: 'block',
            shapeRendering: 'auto',
        }}
        xmlns="http://www.w3.org/2000/svg"
        width={width !== '100%' ? `${width}px` : width}
        height={height !== '100%' ? `${height}px` : height}
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
    >
        <circle cx="30" cy="50" fill="#FF6B00" r="20">
            <animate
                attributeName="cx"
                repeatCount="indefinite"
                dur="1.0204081632653061s"
                keyTimes="0;0.5;1"
                values="30;70;30"
                begin="-0.5102040816326531s"
            ></animate>
        </circle>
        <circle cx="70" cy="50" fill="#323232" r="20">
            <animate
                attributeName="cx"
                repeatCount="indefinite"
                dur="1.0204081632653061s"
                keyTimes="0;0.5;1"
                values="30;70;30"
                begin="0s"
            ></animate>
        </circle>
        <circle cx="30" cy="50" fill="#FF6B00" r="20">
            <animate
                attributeName="cx"
                repeatCount="indefinite"
                dur="1.0204081632653061s"
                keyTimes="0;0.5;1"
                values="30;70;30"
                begin="-0.5102040816326531s"
            ></animate>
            <animate
                attributeName="fill-opacity"
                values="0;0;1;1"
                calcMode="discrete"
                keyTimes="0;0.499;0.5;1"
                dur="1.0204081632653061s"
                repeatCount="indefinite"
            ></animate>
        </circle>
    </svg>
);

export default Loader;
